<template>
    <v-card>
        <v-card-title class="headline">Xóa xe {{vehicle.plate}}?</v-card-title>
        <v-card-text>
            <v-form v-model="deleteVehicleForm.isValid" ref="deleteVehicleForm">
                Vui lòng nhập lý do xóa xe {{vehicle.plate}}
                <v-textarea
                    v-model="deleteVehicleForm.remark"
                    label="Lý do xóa xe"
                    :rules="[validate.required]"
                ></v-textarea>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="$emit('show', false)">Từ chối</v-btn>
            <v-btn
                flat
                color="primary"
                @click.native="deleteVehicleSubmit()"
                :loading="deleteVehicleForm.isLoading"
            >Đồng ý</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import validate from '@/utils/validate';

export default {
  props: {
    vehicle: Object
  },
  data () {
    return {
      validate: validate,
      deleteVehicleForm: {
        isValid: false,
        isLoading: false,
        remark: ''
      },
    };
  },
  methods: {
    ...mapActions(['deleteVehicles']),

    deleteVehicleSubmit () {
      if (this.deleteVehicleForm.isValid) {
        this.deleteVehicleForm.isLoading = true;
        this.deleteVehicles({
          ids: [this.vehicle.id],
          remark: this.deleteVehicleForm.remark
        })
          .then(res => {
            this.deleteVehicleForm.isLoading = false;
            this.$emit('show', false);
            window.getApp.showMessage(
              `Xóa xe ${this.vehicle.plate} thành công`
            );
            setTimeout(() => {
              window.location.reload();
            }, 500);
          })
          .catch(_ => {
            this.deleteVehicleForm.isLoading = false;
            window.getApp.showMessage(
              'Xóa xe thất bại, vui lòng thử lại',
              'error'
            );
          });
      } else {
        this.$refs.deleteVehicleForm.validate();
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/vehicle/components/Delete.vue